module.exports = __webpack_public_path__ + "img/next_btn.18517821.png";